'use client'

import { Text, Button } from "@medusajs/ui"
import { getProductPrice } from "@lib/util/get-product-price"
import { getDiscountedPrice } from "@lib/util/promotions"
import { usePromotions } from "@lib/context/promotions-context"
import { HttpTypes } from "@medusajs/types"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import Thumbnail from "../thumbnail"
import PreviewPrice from "./price"
import { ShoppingCart } from "lucide-react"
import ProductActionsList from "../product-actions-list"

// import { useCart } from "medusa-react"

export default function ProductPreview({
  product,
  isFeatured,
  region,
}: {
  product: HttpTypes.StoreProduct
  isFeatured?: boolean
  region: HttpTypes.StoreRegion
}) {
  const { cheapestPrice } = getProductPrice({ product })
  const promotions = usePromotions()

  // Descuento por promociones automáticas de Medusa: los hits de MeiliSearch
  // traen `salesPriceWithIva` precalculado; los productos de la API de Medusa
  // se evalúan contra las promociones del contexto.
  const discounted = cheapestPrice
    ? getDiscountedPrice(
        product,
        promotions,
        cheapestPrice.calculated_price_number,
        cheapestPrice.currency_code.toUpperCase()
      )
    : null

  // % de descuento para el distintivo sobre la imagen (mismo criterio que
  // price.tsx: solo cuando el precio de oferta es inferior al calculado).
  const discountPct =
    typeof discounted === "number" &&
    cheapestPrice &&
    discounted < cheapestPrice.calculated_price_number
      ? Math.round((1 - discounted / cheapestPrice.calculated_price_number) * 100)
      : null
  // const { addItem } = useCart()

  const capitalize = (str: string) => {
    if (!str) return ""
    const lowerStr = str.toLowerCase()
    return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1)
  }

  const handleAddToCart = async (e: React.MouseEvent) => {
    // e.preventDefault() // evita que se dispare el enlace al producto
    // if (!product?.variants?.length) return

    // // Cogemos el primer variant disponible
    // const variantId = product.variants[0].id

    // try {
    //   await addItem({
    //     variant_id: variantId,
    //     quantity: 1,
    //   })
    //   console.log("Producto añadido al carrito ✅")
    // } catch (err) {
    //   console.error("Error al añadir al carrito", err)
    // }
  }

  return (
    <div data-testid="product-wrapper" className="group">
      <LocalizedClientLink href={`/products/${product.handle}`}>
        <div className="relative">
          <Thumbnail
            thumbnail={product.thumbnail}
            images={product.images}
            size="full"
            isFeatured={isFeatured}
            title={product.title}
          />
          {discountPct !== null && (
            <div className="absolute left-2 top-2 z-10 rounded-full bg-[#f57aa9] px-2 py-1 text-xs font-bold text-white shadow-sm">
              -{discountPct}%
            </div>
          )}
        </div>
        <div className="flex txt-compact-medium mt-4 justify-between">
          <Text
            className="text-ui-fg-subtle font-semibold"
            data-testid="product-title"
          >
            {capitalize(product.title)}
          </Text>
          <div className="flex items-center gap-x-2">
            {cheapestPrice && (
              <PreviewPrice
                price={cheapestPrice}
                discounted={discounted}
              />
            )}
          </div>
        </div>
      </LocalizedClientLink>

      <ProductActionsList
        // disabled={true}
        product={product}
        region={region}
      />

      {/* Botón fuera del link */}
      {/* <div className="mt-2">
        <Button
          onClick={handleAddToCart}
          size="small"
          className="w-full bg-[#f599a6] hover:bg-[#e06692] text-white font-semibold transition-colors rounded-md border-0 shadow-sm flex items-center justify-center gap-2"
        >
          <ShoppingCart className="w-4 h-4" />
          Añadir al carrito
        </Button>
      </div> */}

    </div>
  )
}
